import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { getformatstruct, getformListItemsdatas, setImgsize } from "@/utils/utils";
export default {
  name: 'sourcematerial',
  components: {},
  meta: {
    title: ''
  },
  props: {
    value: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      openFlag: false,
      sourcestructList: [],
      sourcesform: {},
      sourcelabel: {},
      sourcefield: {},
      sourceoption: {},
      sourceList: [],
      bgTypeList: [],
      // 背景分类数据
      bgTypeIndex: 0,
      // 背景类型索引
      sourceform: {
        deptId: '186266',
        formId: '2184030',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ab25462e5537dda01f7d25b07b7844e2cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 素材库请求参数
      picList: [],
      listIndex: '',
      sourceType: 0,
      // 素材分类 score值
      sourcePic: [],
      // 默认图片
      sourceTitle: '',
      // 弹窗标题
      materialType: [],
      // 素材分类数据
      poptitle: '',
      selectItem: {} // 选中的图片信息
    };
  },
  created() {},
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    /**
     * 素材库表单结构
     * @date 2025-06-13
     * @update 2025-07-10
     */
    setStructForm(val) {
      this.sourcestructList = val;
      this.sourceList = getformatstruct(val, this.sourcesform, this.sourcelabel, this.sourcefield, this.sourceoption);
      this.bgTypeList = this.sourceoption.style_type.map(item => {
        return item.title;
      });
      this.materialType = this.sourceoption.material_type;
      this.getrelevantData();
    },
    getrelevantData() {
      let typedata = this.materialType.find(item => {
        return item.score === this.sourceType;
      });
      this.sourceTitle !== undefined ? this.poptitle = this.sourceTitle : this.setPoptitle(typedata.score);
      this.getData(typedata.title);
    },
    setPoptitle(score) {
      let result;
      switch (score) {
        case 0:
          result = '背景素材库';
          break;
        case 2:
          result = '分类按钮库';
          break;
        case 3:
          result = '图标/图片库';
          break;
        default:
          result = '设置';
      }
      this.poptitle = result;
    },
    /**
     * 获取素材库表单数据
     * @param {String} type 素材类型
     * @param {String} bgtype 背景素材类型
     * @date 2025-06-13
     */
    getData(type, bgtype) {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'material_type',
            'compt': 'selectbox',
            'express': '===',
            'val': [type]
          }]
        }]
      };
      if (bgtype !== undefined && bgtype !== '') {
        searchStr.filters.push({
          "model": 0,
          "filters": [{
            'alias': 'style_type',
            'compt': 'selectbox',
            'express': '===',
            'val': [bgtype]
          }]
        });
      }
      if (this.typebtnIndex !== undefined && this.typebtnIndex !== '') {
        searchStr.filters.push({
          "model": 0,
          "filters": [{
            'alias': 'type_button',
            'compt': 'selectbox',
            'express': '===',
            'val': [this.typebtnIndex === 0 ? '默认' : '选中']
          }]
        });
      }
      this.sourceform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.sourceform).then(res => {
        if (res.totalRow > 0) {
          let hasIndex = '';
          that.picList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            if (that.sourcePic.length > 0 && itemformat.picture_upload.length > 0 && that.sourcePic[0].objectId === itemformat.picture_upload[0].objectId) {
              hasIndex = index;
            }
            return item;
          });
          that.listIndex = hasIndex;
          console.log(`that.picList`, that.picList);
        }
      });
    },
    setImg(val) {
      return this.sourceType === 0 ? setImgsize(val, 234, 146) : val.fileUrl;
    },
    /**
     * 背景素材库分类点击事件
     * @date 2025-06-13
     */
    bgTypeclick(item, index) {
      this.bgTypeIndex = index === undefined ? 0 : index + 1;
      let typedata = this.materialType.find(item => {
        return item.score === this.sourceType;
      });
      this.getData(typedata.title, item);
    },
    /**
     * 图片列表点击事件
     * @date 2025-06-13
     */
    selectList(item, index) {
      console.log(`item`, item);
      this.listIndex = index;
      this.selectItem = {
        ...item
      };
    },
    /**
     * 打开素材库弹窗
    * @param {Object} val 数据
     * @date 2025-06-13
     */
    openSourceMaterial(val) {
      console.log(`openSourceMaterial`, val);
      if (this.sourcestructList.length === 0) this.setStructForm(this.value);
      this.openFlag = true;
      this.sourceType = val.type;
      this.sourcePic = val.pic === undefined ? [] : val.pic;
      this.sourceTitle = val.title;
      this.typebtnIndex = val.typebtnIndex === undefined ? '' : Number(val.typebtnIndex);
      this.getrelevantData();
    },
    /**
     * 关闭素材库弹窗
     * @date 2025-06-13
     */
    closeSourceMaterial() {
      this.openFlag = false;
      this.typebtnIndex = '';
    },
    /**
     * 确定事件
     * @date 2025-06-13
     */
    saveHandle() {
      this.openFlag = false;
      this.typebtnIndex = '';
      let info = {
        type: this.sourceType,
        title: this.sourceTitle,
        data: this.selectItem
      };
      this.$emit('submit', info);
    }
  }
};